import React, { useState, useEffect } from 'react';
import { 
  Sparkles, 
  Users, 
  Calendar, 
  Shield, 
  Heart, 
  Compass, 
  Award 
} from 'lucide-react';
import StudentLifeHeroForm from './StudentLifeHeroForm';
import StudentLifeClubsForm from './StudentLifeClubsForm';
import StudentLifeEventsForm from './StudentLifeEventsForm';
import StudentLifeHouseSystemForm from './StudentLifeHouseSystemForm';
import StudentLifeWellbeingForm from './StudentLifeWellbeingForm';
import StudentLifeCharacterShapingForm from './StudentLifeCharacterShapingForm';
import StudentLifeLeapsForm from './StudentLifeLeapsForm';
import StudentLifeHouseDetailsForm from './StudentLifeHouseDetailsForm';
import './FormsUnified.css';

export default function StudentLifeForm({ apiBase, activeTab }) {
  const [currentSection, setCurrentSection] = useState('hero');

  useEffect(() => {
    if (activeTab === 'cms-sl-hero' || activeTab === 'cms-life-hero' || activeTab === 'hero') {
      setCurrentSection('hero');
    } else if (activeTab === 'cms-sl-clubs' || activeTab === 'cms-life-clubs' || activeTab === 'clubs') {
      setCurrentSection('clubs');
    } else if (activeTab === 'cms-sl-events' || activeTab === 'cms-life-events' || activeTab === 'events') {
      setCurrentSection('events');
    } else if (activeTab === 'cms-sl-houses' || activeTab === 'cms-life-house-system' || activeTab === 'houses') {
      setCurrentSection('houses');
    } else if (activeTab === 'cms-sl-wellbeing' || activeTab === 'cms-life-wellbeing' || activeTab === 'wellbeing') {
      setCurrentSection('wellbeing');
    } else if (activeTab === 'cms-sl-character' || activeTab === 'cms-life-character-shaping' || activeTab === 'character') {
      setCurrentSection('character');
    } else if (activeTab === 'cms-sl-leaps' || activeTab === 'cms-life-leaps' || activeTab === 'leaps') {
      setCurrentSection('leaps');
    } else if (activeTab === 'cms-sl-house-details' || activeTab === 'house-details') {
      setCurrentSection('house-details');
    }
  }, [activeTab]);

  return (
    <div className="unified-master-container">
      {/* Tab Navigation Pill Bar */}
      <div className="unified-tab-bar">
        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'hero' ? 'active' : ''}`}
          onClick={() => setCurrentSection('hero')}
        >
          <Sparkles className="w-4 h-4 mr-2" />
          <span>Hero Section</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'clubs' ? 'active' : ''}`}
          onClick={() => setCurrentSection('clubs')}
        >
          <Users className="w-4 h-4 mr-2" />
          <span>Clubs & ECA</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'events' ? 'active' : ''}`}
          onClick={() => setCurrentSection('events')}
        >
          <Calendar className="w-4 h-4 mr-2" />
          <span>Event & Competition</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'houses' ? 'active' : ''}`}
          onClick={() => setCurrentSection('houses')}
        >
          <Shield className="w-4 h-4 mr-2" />
          <span>House System</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'wellbeing' ? 'active' : ''}`}
          onClick={() => setCurrentSection('wellbeing')}
        >
          <Heart className="w-4 h-4 mr-2" />
          <span>Wellbeing & SEL</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'character' ? 'active' : ''}`}
          onClick={() => setCurrentSection('character')}
        >
          <Compass className="w-4 h-4 mr-2" />
          <span>Character Shaping</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'house-details' ? 'active' : ''}`}
          onClick={() => setCurrentSection('house-details')}
        >
          <Shield className="w-4 h-4 mr-2" />
          <span>House Detail Pages</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'leaps' ? 'active' : ''}`}
          onClick={() => setCurrentSection('leaps')}
        >
          <Award className="w-4 h-4 mr-2" />
          <span>LEAPS Framework</span>
        </button>
      </div>

      {/* Render Active Section Form */}
      <div className="unified-tab-content">
        {currentSection === 'hero' && <StudentLifeHeroForm apiBase={apiBase} />}
        {currentSection === 'clubs' && <StudentLifeClubsForm apiBase={apiBase} />}
        {currentSection === 'events' && <StudentLifeEventsForm apiBase={apiBase} />}
        {currentSection === 'houses' && <StudentLifeHouseSystemForm apiBase={apiBase} />}
        {currentSection === 'house-details' && <StudentLifeHouseDetailsForm apiBase={apiBase} />}
        {currentSection === 'wellbeing' && <StudentLifeWellbeingForm apiBase={apiBase} />}
        {currentSection === 'character' && <StudentLifeCharacterShapingForm apiBase={apiBase} />}
        {currentSection === 'leaps' && <StudentLifeLeapsForm apiBase={apiBase} />}
      </div>
    </div>
  );
}
